// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-container {
  display: flex;
  flex-direction: column;
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px;
  background-color: #f8f9ef;
  border-radius: 8px;
}

.personal-container {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.photo-container {
  flex: 1 1;
}

.representative-container {
  flex: 2 1;
}

/* Profile - Foto + Formulários */

.profile-photo {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-photo img {
  width: 238px;
  height: 238px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 10px;
}

.btn-save-edit {
  margin: 20px 0;
}

.profile-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  align-items: center;
  gap: 20px;
}

.form-group label {
  text-align: right;
}

.form-group input {
  flex: 1 1;
  color: #333;
  background-color: #f0f0f0;
  border: 1px solid #a1a1a1;
  padding: 10px;
  border-radius: 5px;
}

.form-group input:focus {
  border: 1px solid #27ae60;
  outline: none;
}

.form-group select {
  flex: 1 1;
  color: #333;
  background-color: #f0f0f0;
  border: 1px solid #a1a1a1;
  padding: 10px;
  border-radius: 5px;
}

.company-container {
  margin: 50px 0;
}

.pdf-link {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  font-size: 1.1rem;
  font-weight: 600;
  background: none;
  border: none;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
  color: rgb(1, 1, 83);
}

.pdf-upload {
  display: flex;
  align-items: center;
  gap: 20px;
}

.pdf-upload label {
  text-align: right;
}

input[type='file'] {
  display: none;
}

.btn-upload {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 250px;
}

.disabled-input {
  background-color: #f0f0f0 !important;
  color: #a0a0a0 !important;
  cursor: not-allowed;
}

.file-name {
  margin-left: 10px;
  font-size: 1rem;
  color: #333;
}

.file-name.uploaded-file {
  color: #64a555;
  font-weight: 500;
}

.file-name.uploaded-file i {
  margin-right: 5px;
  color: #64a555;
}

.file-name.pdf-link {
  background: none;
  border: none;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s ease;
}

.file-name.pdf-link:hover:not(:disabled) {
  color: #4a7c59;
  text-decoration: none;
}

.file-name.pdf-link:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  text-decoration: none;
}

/* Profile - Adicionar uma Exploração */

.exploration-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.edit-container {
  display: flex;
  flex-direction: column; /* Change to column to align items vertically */
  justify-content: center;
  flex: 1 1;
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.exploration-subtitle {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 20rem;
}

.btn-add-exploration {
  display: block;
  width: 100%;
  background: #64a555;
  outline: 0;
  border: 0;
  border-radius: 100px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  padding: 10px 20px;
  margin: 1rem 0;
  cursor: pointer;
}

.btn-save-exploration {
  width: 100%;
  background: #64a555;
  outline: 0;
  border: 0;
  border-radius: 100px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  padding: 10px 20px;
  margin-bottom: 10px;
  cursor: pointer;
}

.btn-save-exploration:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.btn-edit-exploration,
.btn-edit-culture {
  width: 200px;
  background: #333;
  outline: 0;
  border: 0;
  border-radius: 100px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  padding: 10px 20px;
  margin: 10px;
  cursor: pointer;
}

.btn-add-exploration i,
.btn-edit-exploration i,
.btn-save-exploration i,
.btn-add-culture i,
.btn-edit-culture i .btn-save-culture i {
  font-size: 1rem;
  padding-left: 10px;
}

.exploration-container {
  display: flex;
  flex-direction: column;
  background-color: #f8f9ef;
  border-radius: 8px;
  margin-top: 2%;
}

/* Profile - Adicionar uma Cultura */

.culture-container {
  display: flex;
  flex-direction: column;
  background-color: #f8f9ef;
  border-radius: 8px;
  margin-top: 2%;
}

.edit-container-culture {
  display: flex;
  justify-content: center;
  flex: 1 1;
  background-color: #f8f9ef;
  padding: 0.5rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.culture-subtitle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-add-culture {
  display: block;
  width: 100%;
  background: #64a555;
  outline: 0;
  border: 0;
  border-radius: 100px;
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  padding: 10px 20px;
  margin: 10px;
  cursor: pointer;
}

.btn-edit-culture {
  margin-left: 10rem;
}

/* Profile - Container de Edição de Explorações e Culturas */

.edit-container {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 1.5rem;
  margin-bottom: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.exploration-list {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}

.exploration-list .exploration-title {
  margin-right: auto;
}

.exploration-list .btn-edit-exploration {
  max-width: 250px;
  flex: 2 1;
}

.exploration-list .btn-add-culture {
  max-width: 250px;
  flex: 2 1;
}

.cultures-list {
  margin-top: 20px;
  background-color: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.cultures-list ul {
  list-style-type: none;
  padding: 0;
}

.cultures-list li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  padding: 10px 0;
  border-bottom: 1px solid #ddd;
}

.cultures-list li:last-child {
  border-bottom: none;
}

.cultures-list li .btn-edit-culture {
  width: 250px;
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/css/sg-profile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAO;AACT;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,+CAA+C;EACvE,uBAAuB;EACvB,SAAO;EACP,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,oCAAoC;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAO;EACP,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4DAA4D;;AAE5D;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".profile-container {\n  display: flex;\n  flex-direction: column;\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 20px;\n  background-color: #f8f9ef;\n  border-radius: 8px;\n}\n\n.personal-container {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n}\n\n.photo-container {\n  flex: 1;\n}\n\n.representative-container {\n  flex: 2;\n}\n\n/* Profile - Foto + Formulários */\n\n.profile-photo {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.profile-photo img {\n  width: 238px;\n  height: 238px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-bottom: 10px;\n}\n\n.btn-save-edit {\n  margin: 20px 0;\n}\n\n.profile-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.form-group label {\n  text-align: right;\n}\n\n.form-group input {\n  flex: 1;\n  color: #333;\n  background-color: #f0f0f0;\n  border: 1px solid #a1a1a1;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.form-group input:focus {\n  border: 1px solid #27ae60;\n  outline: none;\n}\n\n.form-group select {\n  flex: 1;\n  color: #333;\n  background-color: #f0f0f0;\n  border: 1px solid #a1a1a1;\n  padding: 10px;\n  border-radius: 5px;\n}\n\n.company-container {\n  margin: 50px 0;\n}\n\n.pdf-link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  background: none;\n  border: none;\n  padding: 0;\n  text-decoration: underline;\n  cursor: pointer;\n  color: rgb(1, 1, 83);\n}\n\n.pdf-upload {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.pdf-upload label {\n  text-align: right;\n}\n\ninput[type='file'] {\n  display: none;\n}\n\n.btn-upload {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  max-width: 250px;\n}\n\n.disabled-input {\n  background-color: #f0f0f0 !important;\n  color: #a0a0a0 !important;\n  cursor: not-allowed;\n}\n\n.file-name {\n  margin-left: 10px;\n  font-size: 1rem;\n  color: #333;\n}\n\n.file-name.uploaded-file {\n  color: #64a555;\n  font-weight: 500;\n}\n\n.file-name.uploaded-file i {\n  margin-right: 5px;\n  color: #64a555;\n}\n\n.file-name.pdf-link {\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n  transition: color 0.2s ease;\n}\n\n.file-name.pdf-link:hover:not(:disabled) {\n  color: #4a7c59;\n  text-decoration: none;\n}\n\n.file-name.pdf-link:disabled {\n  cursor: not-allowed;\n  opacity: 0.6;\n  text-decoration: none;\n}\n\n/* Profile - Adicionar uma Exploração */\n\n.exploration-title {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 20px;\n}\n\n.edit-container {\n  display: flex;\n  flex-direction: column; /* Change to column to align items vertically */\n  justify-content: center;\n  flex: 1;\n  background-color: #fff;\n  padding: 1.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.exploration-subtitle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-left: 20rem;\n}\n\n.btn-add-exploration {\n  display: block;\n  width: 100%;\n  background: #64a555;\n  outline: 0;\n  border: 0;\n  border-radius: 100px;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 10px 20px;\n  margin: 1rem 0;\n  cursor: pointer;\n}\n\n.btn-save-exploration {\n  width: 100%;\n  background: #64a555;\n  outline: 0;\n  border: 0;\n  border-radius: 100px;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 10px 20px;\n  margin-bottom: 10px;\n  cursor: pointer;\n}\n\n.btn-save-exploration:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.btn-edit-exploration,\n.btn-edit-culture {\n  width: 200px;\n  background: #333;\n  outline: 0;\n  border: 0;\n  border-radius: 100px;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 10px 20px;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.btn-add-exploration i,\n.btn-edit-exploration i,\n.btn-save-exploration i,\n.btn-add-culture i,\n.btn-edit-culture i .btn-save-culture i {\n  font-size: 1rem;\n  padding-left: 10px;\n}\n\n.exploration-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9ef;\n  border-radius: 8px;\n  margin-top: 2%;\n}\n\n/* Profile - Adicionar uma Cultura */\n\n.culture-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #f8f9ef;\n  border-radius: 8px;\n  margin-top: 2%;\n}\n\n.edit-container-culture {\n  display: flex;\n  justify-content: center;\n  flex: 1;\n  background-color: #f8f9ef;\n  padding: 0.5rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n.culture-subtitle {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.btn-add-culture {\n  display: block;\n  width: 100%;\n  background: #64a555;\n  outline: 0;\n  border: 0;\n  border-radius: 100px;\n  color: #fff;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-decoration: none;\n  padding: 10px 20px;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.btn-edit-culture {\n  margin-left: 10rem;\n}\n\n/* Profile - Container de Edição de Explorações e Culturas */\n\n.edit-container {\n  display: flex;\n  flex-direction: column;\n  background-color: #fff;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.exploration-list {\n  display: flex;\n  align-items: center;\n  background-color: #f9f9f9;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  margin-bottom: 2rem;\n}\n\n.exploration-list .exploration-title {\n  margin-right: auto;\n}\n\n.exploration-list .btn-edit-exploration {\n  max-width: 250px;\n  flex: 2;\n}\n\n.exploration-list .btn-add-culture {\n  max-width: 250px;\n  flex: 2;\n}\n\n.cultures-list {\n  margin-top: 20px;\n  background-color: #f9f9f9;\n  padding: 1rem;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.cultures-list ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n.cultures-list li {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #333;\n  padding: 10px 0;\n  border-bottom: 1px solid #ddd;\n}\n\n.cultures-list li:last-child {\n  border-bottom: none;\n}\n\n.cultures-list li .btn-edit-culture {\n  width: 250px;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
